export const FUND_COMPLIANCE_AUTH_INVALIDATED_EVENT = "fund-compliance-auth-invalidated";

export function notifyFundComplianceAuthInvalidated() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(FUND_COMPLIANCE_AUTH_INVALIDATED_EVENT));
}
